export default "__VITE_ASSET__DA6hKZug__"